export const NAICS_CODE_FREE_TEXT = 999999;
